import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ResourceCard from '../components/ResourceCard';
import { trendingResources } from '../data/trendingResources';

import { useAuth } from '../context/AuthContext';
import { useAlertContext } from '../context/AlertContext';
// import axios from 'axios';
// import { API_URL } from '../config/api';
import { FaSearch, FaFilter, FaBook, FaCode, FaPalette, FaChartLine, FaRocket, FaGraduationCap, FaCertificate, FaTimesCircle } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi2';

const ResourceHub = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [modalOpen, setModalOpen] = useState(true);
  const [showBuyBanner, setShowBuyBanner] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useAuth();
  const { showAlert } = useAlertContext();

  const categories = [
    { id: 'all', name: 'All Resources', icon: FaBook },
    { id: 'Course', name: 'Courses', icon: FaGraduationCap },
    { id: 'Certification', name: 'Certification', icon: FaCertificate },
    { id: 'programming', name: 'Programming', icon: FaCode },
    { id: 'Design', name: 'Design', icon: FaPalette },
    { id: 'Business', name: 'Business', icon: FaChartLine },
  ];

  const filteredResources = trendingResources
    .filter(resource => 
      selectedCategory === 'all' || resource.category === selectedCategory
    )
    .filter(resource =>
      resource.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      resource.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

  return (
    <>
      <div className="min-h-screen bg-[#f3f4f6]" style={{
        backgroundImage: `
          radial-gradient(at 0% 0%, rgba(59, 130, 246, 0.15) 0px, transparent 50%),
          radial-gradient(at 100% 0%, rgba(139, 92, 246, 0.15) 0px, transparent 50%),
          radial-gradient(at 100% 100%, rgba(236, 72, 153, 0.15) 0px, transparent 50%),
          radial-gradient(at 0% 100%, rgba(34, 197, 94, 0.15) 0px, transparent 50%)
        `
      }}>
         {/* Top Decoration */}
       <div className="h-[40rem] bg-gradient-to-r from-primary-600 to-indigo-700 w-full absolute top-0 z-0 rounded-b-[3rem] shadow-lg">
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
      </div>

        <div className="container-responsive relative z-10 pt-24 px-4 sm:px-6 lg:px-8 pb-12">
          {/* Header Section */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-md border border-white/30 text-white rounded-full text-sm font-medium mb-6 shadow-lg">
              <FaBook className="w-4 h-4 mr-2" />
              Learning Library
            </div>
            <h1 className="heading-primary mb-6 text-white drop-shadow-lg tracking-tight">
              Resource <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-purple-200">Hub</span>
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto leading-relaxed font-light">
              Curated collection of top-tier courses, certifications, and tools to accelerate your growth.
            </p>
          </div>

          {/* Search & Filter Container */}
          <div className="max-w-5xl mx-auto mb-16 relative">
             <div className="bg-white/90 backdrop-blur-2xl rounded-3xl p-8 border border-white/60 shadow-2xl relative z-10 hover:-translate-y-1 transition-transform duration-300">
                {/* Search Bar */}
                <div className="relative mb-8 group">
                  <div className="absolute inset-y-0 left-0 pl-6 flex items-center pointer-events-none">
                    <FaSearch className="h-5 w-5 text-gray-400 group-focus-within:text-indigo-500 transition-colors" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search for courses, skills, or certifications..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="block w-full pl-14 pr-4 py-4 bg-gray-50 border border-gray-200 text-gray-900 placeholder:text-gray-400 focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 rounded-2xl transition-all duration-300 shadow-inner text-lg"
                  />
                  {searchQuery && (
                      <button 
                        onClick={() => setSearchQuery('')}
                        className="absolute inset-y-0 right-4 flex items-center text-gray-400 hover:text-gray-600"
                      >
                          <FaTimesCircle className="w-5 h-5" />
                      </button>
                  )}
                </div>
                
                {/* Category Filter */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <div className="flex items-center space-x-2 text-gray-500 min-w-fit">
                        <FaFilter className="w-4 h-4 text-indigo-500" />
                        <span className="text-sm font-bold uppercase tracking-wider">Filter By:</span>
                    </div>
                    <div className="flex flex-wrap gap-2">
                        {categories.map((category) => {
                            const Icon = category.icon;
                            const isActive = selectedCategory === category.id;
                            return (
                            <button
                                key={category.id}
                                onClick={() => setSelectedCategory(category.id)}
                                className={`flex items-center space-x-2 px-4 py-2.5 rounded-xl transition-all duration-200 text-sm font-medium border
                                ${isActive
                                    ? 'bg-indigo-600 text-white border-indigo-600 shadow-lg shadow-indigo-200 scale-105'
                                    : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50 hover:border-gray-300'
                                }`}
                            >
                                <Icon className={`w-4 h-4 ${isActive ? 'text-white' : 'text-gray-400'}`} />
                                <span>{category.name}</span>
                            </button>
                            );
                        })}
                    </div>
                </div>
             </div>
             
             {/* Decorative Elements behind search bar */}
             <div className="absolute -top-4 -left-4 w-24 h-24 bg-blue-500/20 rounded-full blur-2xl -z-10 animate-pulse"></div>
             <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-purple-500/20 rounded-full blur-2xl -z-10 animate-pulse delay-700"></div>
          </div>

          {/* Resources Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {filteredResources.map((resource, index) => (
              <Link to={`/resource/${resource.id}`} key={resource.id} className="block h-full">
                <ResourceCard resource={resource} />
              </Link>
            ))}
          </div>

          {/* Empty State */}
          {filteredResources.length === 0 && (
            <div className="text-center py-24 bg-white/60 backdrop-blur-md rounded-3xl border border-white/40 shadow-sm mx-auto max-w-2xl">
              <div className="w-24 h-24 bg-indigo-50 rounded-full flex items-center justify-center mx-auto mb-6 shadow-iner">
                <HiSparkles className="w-12 h-12 text-indigo-400" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">No resources found</h3>
              <p className="text-gray-600 mb-8 max-w-md mx-auto">
                We couldn't find any resources matching "{searchQuery}" in {selectedCategory === 'all' ? 'any category' : categories.find(c => c.id === selectedCategory)?.name}.
              </p>
              <button 
                onClick={() => {
                  setSearchQuery('');
                  setSelectedCategory('all');
                }}
                className="px-8 py-3 bg-white border border-gray-300 text-gray-700 font-bold rounded-xl hover:bg-indigo-50 hover:border-indigo-200 hover:text-indigo-600 transition-all shadow-sm"
              >
                Clear All Filters
              </button>
            </div>
          )}

          {/* Stats Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
             <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-8 text-center shadow-lg border border-white/50 relative overflow-hidden group hover:shadow-xl hover:-translate-y-1 transition-all">
                <div className="absolute -right-6 -top-6 bg-blue-50 w-32 h-32 rounded-full group-hover:scale-110 transition-transform"></div>
                <div className="relative z-10">
                    <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center text-2xl font-bold mx-auto mb-4 group-hover:rotate-12 transition-transform shadow-sm">
                        <FaBook />
                    </div>
                    <h4 className="text-4xl font-extrabold text-gray-900 mb-1">{trendingResources.length}+</h4>
                    <p className="text-gray-500 font-medium">Curated Resources</p>
                </div>
             </div>

             <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-8 text-center shadow-lg border border-white/50 relative overflow-hidden group hover:shadow-xl hover:-translate-y-1 transition-all">
                <div className="absolute -right-6 -top-6 bg-purple-50 w-32 h-32 rounded-full group-hover:scale-110 transition-transform"></div>
                <div className="relative z-10">
                    <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center text-2xl font-bold mx-auto mb-4 group-hover:rotate-12 transition-transform shadow-sm">
                        <FaFilter />
                    </div>
                    <h4 className="text-4xl font-extrabold text-gray-900 mb-1">{categories.length - 1}</h4>
                    <p className="text-gray-500 font-medium">Learning Categories</p>
                </div>
             </div>

             <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-8 text-center shadow-lg border border-white/50 relative overflow-hidden group hover:shadow-xl hover:-translate-y-1 transition-all">
                <div className="absolute -right-6 -top-6 bg-pink-50 w-32 h-32 rounded-full group-hover:scale-110 transition-transform"></div>
                <div className="relative z-10">
                    <div className="w-16 h-16 bg-pink-100 text-pink-600 rounded-2xl flex items-center justify-center text-2xl font-bold mx-auto mb-4 group-hover:rotate-12 transition-transform shadow-sm">
                       <FaRocket />
                    </div>
                    <h4 className="text-4xl font-extrabold text-gray-900 mb-1">
                       {Math.round(trendingResources.reduce((acc, curr) => acc + curr.rating, 0) / trendingResources.length * 10) / 10}
                    </h4>
                    <p className="text-gray-500 font-medium">Average Rating</p>
                </div>
             </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default ResourceHub;